import angular from 'angular'
import orgSelectDirective from './orgSelectDirective'

export default angular
    .module('app.orgSelect', [])
    .directive('orgSelect', orgSelectDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/orgSelect/index.js